<template>
  <div>
    <table class="table table-striped" style="border-bottom: 1px solid #dee2e6">
      <thead>
        <tr>
          <th
            class="text-truncate"
            style="background-color: #334697; color: white"
            >Engine Name</th
          >
          <th
            class="text-truncate"
            style="background-color: #334697; color: white"
            >Lates Input RH (Date)</th
          >
          <th
            class="text-truncate"
            style="background-color: #334697; color: white"
            >Lates Input RH (Hours)</th
          >
          <th
            class="text-truncate"
            style="background-color: #334697; color: white"
            >Total RH</th
          >
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rh, engineIndex) in runningHours" :key="engineIndex">
          <td>
            <strong>{{ rh?.power_type?.name }}</strong>
            <br />
            <small>{{ rh?.power_series?.name }} - {{ rh?.power_series?.model }}</small>
          </td>
          <td class="text-truncate">{{ formatDate(rh.last_rh_date) }}</td>
          <td class="text-truncate">{{ Number(rh?.this_month).toLocaleString() }} Hours</td>
          <td class="text-truncate">{{ Number(rh?.total_running_hour).toLocaleString() }} Hours</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { pmsActions } from '@/src/Utils/helper'
import moment from 'moment'

export default {
  name: 'MaintenanceRhList',
  props: {
    maintenanceDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      runningHours: [],
    }
  },
  methods: {
    ...pmsActions,
    async fetchData() {
      const params = {
        vehicle_id: this.maintenanceDetailData?.vehicle?.id,
      }
      const res = await this.getPmsRunningHours(params)

      if (res?.status === 'success') {
        this.runningHours = res.data.data
        console.log(this.runningHours)
      } else {
        console.log(res)
      }
      this.loading = false
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '-'
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped>
.font-medium {
  font-weight: 500;
}
</style>
